export enum RouteIdentifierType {
  route_id = 'route_id',
  route_code = 'route_code'
}
